import React, { useCallback, useState } from 'react';
import { Input, message, Modal } from 'antd';
import { FiCheckCircle, FiXCircle } from 'react-icons/fi';
import Form from '../../../../components/Form';
import CastersApi from '../../../../services/sdks/caster';

const ChangeCasterPassword = ({ isOpen, onClose, casterId }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [password, setPassword] = useState('');
	const [passwordConfirmation, setPasswordConfirmation] = useState('');
	const [hasError, setHasError] = useState(false);

	const handleChangePassword = useCallback(async () => {
		setHasError(false);

		if (password !== passwordConfirmation) {
			return setHasError(true);
		}

		try {
			setIsLoading(true);
			await CastersApi.updatePassword(casterId, { password, passwordConfirmation });
			message.success('Senha alterada com sucesso', 2, () => {
				onClose();
				setIsLoading(false);
			});
		} catch (error) {
			message.error('Houve um erro, tente novamente');
			setIsLoading(false);
		}
	}, [casterId, onClose, password, passwordConfirmation]);

	return (
		<Modal
			destroyOnClose
			visible={isOpen}
			onCancel={onClose}
			title='Alterar senha do locutor'
			onOk={handleChangePassword}
			okButtonProps={{ loading: isLoading, disabled: !password || !passwordConfirmation }}
			cancelButtonProps={{ disabled: isLoading }}
			okText={
				<>
					<FiCheckCircle />
					Confirmar
				</>
			}
			cancelText={
				<>
					<FiXCircle />
					Cancelar
				</>
			}>
			<Form.Container>
				<Form.Item label='Senha'>
					<Input.Password
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						size='large'
						placeholder='Senha'
					/>
				</Form.Item>
				<Form.Item error={hasError} errorMessage='Senhas não são iguais' label='Confirmar Senha'>
					<Input.Password
						name='passwordConfirmation'
						value={passwordConfirmation}
						onChange={(e) => setPasswordConfirmation(e.target.value)}
						size='large'
						placeholder='Confirmar senha'
					/>
				</Form.Item>
			</Form.Container>
		</Modal>
	);
};

export default ChangeCasterPassword;
